import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-1e69c1f0"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
    key: 0,
    class: "message_list"
};
const _hoisted_2 = ["onClick"];
const _hoisted_3 = { class: "title" };
const _hoisted_4 = { class: "message_icon_box" };
const _hoisted_5 = {
    key: 0,
    class: "dot"
};
const _hoisted_6 = { class: "text" };
const _hoisted_7 = { class: "time" };
const _hoisted_8 = {
    key: 1,
    class: "no_data_box"
};
import NoData from "@/components/NoData/index.vue";
import { getMessageList } from "@/service/message";
import day from "dayjs";
import { ref } from "vue";
import { useRouter } from "vue-router";
export default /*#__PURE__*/ _defineComponent({
    name: 'MessageList',
    props: {
        count: { default: 5 }
    },
    emits: ["list-click"],
    setup(__props, { expose, emit }) {
        const props = __props;
        const router = useRouter();
        const messageList = ref([]);
        const handleGoDetail = (item) => {
            router.push({ path: "/message/detail", query: { id: item.id } });
            emit("list-click");
        };
        // 获取消息列表
        const loadMessageList = async () => {
            const res = await getMessageList({ page_size: props.count });
            messageList.value = res.data.message_list;
            res.data.message_list.forEach((item) => {
                if (day(item.created_at).format("YYYY") ===
                    new Date().getFullYear() + "") {
                    item.created_at = day(item.created_at).format("MM-DD");
                }
                else {
                    item.created_at = day(item.created_at).format("YYYY-MM-DD");
                }
            });
        };
        // 暴露方法给父组件调用
        expose({
            loadMessageList
        });
        return (_ctx, _cache) => {
            const _component_svg_icon = _resolveComponent("svg-icon");
            const _directive_loading = _resolveDirective("loading");
            return (messageList.value.length)
                ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(messageList.value, (item) => {
                        return (_openBlock(), _createElementBlock("div", {
                            key: item.id,
                            class: "message_content",
                            onClick: _withModifiers(($event) => (handleGoDetail(item)), ["stop"])
                        }, [
                            _createElementVNode("span", _hoisted_3, [
                                _createElementVNode("div", _hoisted_4, [
                                    _createVNode(_component_svg_icon, {
                                        class: "message2-icon",
                                        "icon-class": "message2"
                                    }),
                                    (item.status === 0)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_5))
                                        : _createCommentVNode("", true)
                                ]),
                                _createElementVNode("span", _hoisted_6, _toDisplayString(item.title), 1)
                            ]),
                            _createElementVNode("span", _hoisted_7, _toDisplayString(item.created_at), 1)
                        ], 8, _hoisted_2));
                    }), 128))
                ])), [
                    [_directive_loading, !messageList.value.length]
                ])
                : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _createVNode(NoData, { "icon-class": "message2" })
                ]));
        };
    }
});
